const randomBytes = (length: number) => {
  const arr = new Array(length);
  arr.fill(0);
  return arr;
};

export {randomBytes};
